import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CAL_DEMO_BOOKING_URL, DISCORD_URL } from '@app/config';
import { environment } from '@env/environment';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-app-store-publishing-cta-section',
  imports: [RouterLink, TuiButton],
  templateUrl: './app-store-publishing-cta-section.component.html',
  styleUrl: './app-store-publishing-cta-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStorePublishingCtaSectionComponent {
  protected readonly bookingUrl = CAL_DEMO_BOOKING_URL;
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
  protected readonly discordUrl = DISCORD_URL;

  constructor() {}
}
